import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { FolderMetaForm, FormSchemaType } from "./form/FolderMetaForm";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addFolder } from "@/sideEffects/api";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";
import { showApiError, showSuccess } from "@/lib/toast";

interface Props {
  onClose: () => void;
  parentId?: string;
  onSuccessfullyAdded: () => void;
}

export const AddFolderDialog: React.FC<Props> = ({ onClose, parentId }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const queryClient = useQueryClient();
  const addFolderMutation = useMutation({
    mutationFn: (values: FormSchemaType) => {
      return addFolder(String(activeFirm?.firmGuid), values.folderName, values.folderColor, parentId || "");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contentFolder"] });
      onClose();
      showSuccess(t("common.addedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <Dialog open onOpenChange={onClose} modal>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("common.add")}</DialogTitle>
          <DialogDescription>
            <FolderMetaForm
              buttonText={t("common.add")}
              onSubmit={(values) => addFolderMutation.mutate(values)}
              isLoading={addFolderMutation.isPending}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
